import React, { useState, useEffect } from "react"; //  alterado BELINI
import { Button, Col, Input, Row } from "antd";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FacebookImg from './Facebook.png';
import InstagramImg from './Instagram.png';
import WhatsappImg from './Whatsapp.png';
import PropTypes from "prop-types"; // Corrigindo erros de Eslint
const Auth = (props) => {

const styles = `
    input[type="checkbox"] {
      margin-right: 10px;
      }
      .Maquinas-page {
      background-color: black;
      color: white; 
      height: 100vh;
      height: 100dvh;
      min-height: 100vh;
      min-height: 100dvh;
      width: 100vw;
      overflow: auto;
      }
      .Auth_rowContainer {
      width: 100%;
      height: 100%;
      }
      .Auth_rowContainer .ant-col {
      height: 100%;
      overflow-y: auto;
      }
      .Auth_colAuthForm {
      padding: 50px;
      display: flex !important;
      align-items: center;
      justify-content: center;
      }
      .Auth_authTitle {
      display: flex;
      align-items: center;
      }
      .Auth_authTitleText {
        padding-left: 5px;
        color: #2f3367;
        font-weight: 600;
        font-size: 32px;
        }
      .Auth_authTitleIcon {
      color: #4196dd;
      height: 24px;
      }
      .Auth_authDescription {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #2f3367;
      max-width: 320px;
      }
      .Auth_itemFieldLabel {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #2f3367;
      }
      .Auth_itemFieldLabelCheckbox {
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      color: #afb6c2;
      }
      .Auth_itemFieldLabelCheckbox a {
      color: #afb6c2;
      text-decoration: underline;
      }
      .Auth_itemFieldError {
      color: #e46772;
      font-size: 14px;
      padding: 2px 0;
      }
      .Auth_authSubmit {
      background: #007dfa !important;
      border-radius: 4px !important;
      width: 100%;
      border: none !important;
      box-shadow: none !important;
      color: #fff !important;
      font-weight: 600 !important;
      font-size: 18px;
      text-transform: uppercase; 
      justify-content: center !important;
      align-items: center !important;
      text-align: center !important;
      display: flex !important;
      min-height: 40px !important;
      line-height: 1.5 !important; 
      white-space: nowrap !important;
      }
      .Auth_authSubmit:hover {
      transform: scale(1.05);
      background-color: rgba(0, 125, 250, 0.761);
      }
      .Auth_authFooter {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      }
      .Auth_itemAuthFooter {
      display: flex;
      padding: 5px 0;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      }
      .Auth_itemAuthFooter>div {
      padding: 0 5px;
      color: #469ae2 !important;
      }
      .Auth_itemAuthFooter>a {
      color: #469ae2 !important;
      text-decoration: underline;
      }
      .Auth_successMessage {
      color: #8fc727;
      font-size: 14px;
      padding: 10px 0;
      text-align: center;
      max-width: 320px;
      }
      .Auth_errorMessage {
      color: #e46772;
      font-size: 14px;
      padding: 10px 0;
      text-align: center;
      max-width: 320px;
      }
      .Auth_errorMessage a {
      color: #e46772;
      text-decoration: underline;
      }
      .Auth_errorMessage a:hover {
      color: #e46772;
      }
      .CenteredText {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #ffffff;
      font-size: 36px;
      font-weight: 500;
      }
      .Auth_AuthImage {
      color: #fff;
      width: 100%;
      height: 100%;
      }
      .Auth_authBlock {
      left: 20%;
      width: 60%;
      top: 25%;
      position: relative;
      }
      .LogoTextImage {
      position: absolute;
      top: 15%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #2f3367;
      font-size: 30px;
      font-weight: 500;
      padding: 0px 10px;
      }
      .MediaIcons {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      padding: 10px;
      position: fixed;
      left: 20%;
      transform: translate(-50%,
          -50%);
      width: auto;
      bottom: 10%;
      }
      .Auth_SocialIcon {
      font-size: 24px;
      color: #2f3367;
      }
      .InstagramIcon {
      margin-left: 80px;
      }
      .WhatsIcon {
      margin-left: 40px;
      }
      .Auth_AuthImage {
      position: relative;
      }
      .Auth_SocialIcon {
      width: 35px;
      height: 35px;
      }    
  . Auth_authTitleText{
    color: white;
  } 

@media only screen and (max-width: 1020px) and (orientation: landscape) {
  .Auth_authTitleText {
    display: none !important;
  }
  .Auth_authBlock {
    width: 95%;
    left: 2.5%;
    top: 2%; 
    position: absolute; 
  }
  .Auth_colAuthForm {
    padding: 10px; 
  }
  .Auth_authDescription {
    font-size: 14px;
    max-width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
  .Auth_authSubmit {
  font-size: 16px;
  padding: 10px;
  margin-top: 10px; 
  text-transform: uppercase; 
  display: flex; 
  font-weight: 600;
  background: #007dfa !important; 
  border-radius: 4px !important; 
  width: 100%; 
  border: none !important;
  box-shadow: none !important;
  color: #000 !important; 
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  display: flex !important;
  min-height: 40px !important; 
  line-height: 1.5 !important; 
  white-space: nowrap !important;
  }
 .MediaIcons {
    position: absolute; 
    bottom: 5px; 
    left: 50%; 
    transform: translateX(-50%); 
    flex-direction: row;
    gap: 20px; 
    width: auto; 
  }
}

@media only screen and (max-width: 760px) and (orientation: portrait) {
.Auth_colAuthForm {
    padding: 10px;
  }
  .Auth_AuthImage {
    display: block !important; 
    position: absolute; 
    bottom: 5%; 
    left: 50%; 
    transform: translateX(-50%); 
    width: 97%; 
    height: auto; 
    margin-top: 20px;
  }
  .Auth_authBlock {
    width: 95%;
    left: 2.5%;
    top: 2%; 
    position: absolute; 
  }
  .Auth_authDescription {
    font-size: 14px;
    max-width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
  .Auth_authSubmit {
  font-size: 16px;
  padding: 8px;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  display: flex !important;
  min-height: 40px !important;
  line-height: 1.5 !important;
  white-space: nowrap !important;
  }
  .MediaIcons {
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: row;
    gap: 20px;
    width: auto;
  }
}
.Auth_colAuthForm {
  padding: 20px !important;
  margin-bottom: -10px !important; 
  color: white !important;
}
.Auth_authSubmit {
  width: calc(100% - 24px) !important;
  margin: 12px auto 0 !important;
  display: block !important;
}
.Auth_itemField input {
  color: black !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}
.ant-input-password {
  color: black !important;
  width: 100% !important;
  box-sizing: border-box !important;
}
.Auth_itemField:nth-last-child(2) {
  margin-bottom: 16px !important;
}
.Auth_itemFieldLabelCheckbox {
  margin-top: 8px !important; 
}
.Auth_rowContainer,
.Auth_colAuthForm,
.Auth_authTitle,
.Auth_authDescription,
.Auth_itemFieldLabel,
.Auth_itemFieldLabelCheckbox,
.Auth_authFooter,
.Auth_itemAuthFooter,
.Auth_successMessage,
.Auth_errorMessage,
.CenteredText,
.LogoTextImage {
  color: white !important;
}
.Auth_authTitleText,
.Auth_authTitleIcon,
.Auth_authDescription,
.Auth_itemFieldLabel,
.Auth_itemFieldLabelCheckbox,
.Auth_authSubmit,
.Auth_itemAuthFooter > div,
.Auth_itemAuthFooter > a {
  color: white !important;
}
.Auth_checkbox,
.Auth_authSubmit,
.Auth_itemField input,
.ant-input-password {
  position: relative;
  z-index: 10; 
}
`;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const {
    authFields,
    authSubmit,
    authImage,
    onsubmit,
    successMessage,
    errorMessage,
    textImage,
  } = props;

  const [rememberMe, setRememberMe] = useState(false); //  armazena o valor da checkbox, adicionado BELINI

  useEffect(() => {  // Carrega o estado da checkbox, adicionado BELINI
    const storedRememberMe = localStorage.getItem("rememberMe") === "true";
    setRememberMe(storedRememberMe);
  }, []);

  const handleCheckboxChange = (event) => { // lida com a mudança de estado da checkbox, adicionado BELINI
    const checked = event.target.checked;
    setRememberMe(checked);
    localStorage.setItem("rememberMe", checked);
  };

  return (
    <div className="Maquinas-page">
      <Row className="Auth_rowContainer">

        <Col xs={24} md={10} lg={10} xl={10} className="Auth_AuthForm">
          {textImage && <div className="LogoTextImage">{textImage}</div>}
          <div className="Auth_authBlock">
           
           {/* COLOCAR TÍTULO AQUI */}

           <span
        className="Auth_authTitleText"
        >
        Login Cliente:
      </span>

            <form className="Auth_AuthForm" onSubmit={onsubmit}>
              {authFields.map((itemField, indexField) => {
                switch (itemField.type) {
                  case "text":
                    return (
                      <div className="Auth_itemField" key={indexField}>
                        <label
                          htmlFor="username"
                          className="Auth_itemFieldLabel"
                        >
                          {itemField.label}
                        </label>
                        <Input
                          placeholder={itemField.placeholder ?? ""}
                          value={itemField.value}
                          id="username"
                          type="text"
                          name="username"
                          autoComplete="username"
                          onChange={(event) => {
                            if (typeof itemField.setField === "function") {
                              itemField.setField(event.target.value);
                            }
                          }}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              onsubmit();
                            }
                          }}
                        />
                        {itemField.error && (
                          <div className="Auth_itemFieldError">
                            {itemField.error}
                          </div>
                        )}
                      </div>
                    );
                  case "password":
                    return (
                      <div className="Auth_itemField" key={indexField}>
                        <label
                          htmlFor="password"
                          className="Auth_itemFieldLabel"
                        >
                          {itemField.label}
                        </label>
                        <Input.Password
                          placeholder={itemField.placeholder ?? ""}
                          id="password"
                          value={itemField.value}
                          type="password"
                          name="password"
                          autoComplete="current-password"
                          iconRender={(visible) =>
                            visible ? (
                              <FontAwesomeIcon
                                icon={faEyeSlash}
                              ></FontAwesomeIcon>
                            ) : (
                              <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
                            )
                          }
                          onChange={(event) => {
                            if (typeof itemField.setField === "function") {
                              itemField.setField(event.target.value);
                            }
                          }}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              onsubmit();
                            }
                          }}
                        />
                        {itemField.error && (
                          <div className="Auth_itemFieldError">
                            {itemField.error}
                          </div>
                        )}
                      </div>
                    );
                  default:
                    return null;
                }
              })}


          <div className="Auth_checkbox"> { /* Inicio, adicionado Belini */}
                <label>
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={handleCheckboxChange}
                  />
                  Expirar Sessão após 15 minutos.
                </label>
              </div> { /* Fim, adicionado Belini */}
            </form>
            <Button
              className="Auth_authSubmit"
              onClick={() => {
                if (typeof onsubmit === "function") {
                  onsubmit();
                }
              }}
            >
              {authSubmit}
            </Button>



            {successMessage && (
              <div className="Auth_successMessage">{successMessage}</div>
            )}
            {errorMessage && (
              <div className="Auth_errorMessage">
                <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
              </div>
            )}
          </div>

          <div className="MediaIcons">
            <a
              href="https://www.facebook.com/pagmaq?mibextid=9R9pXO"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={FacebookImg} alt="Facebook" className="Auth_SocialIcon" />
            </a>
            <a
              href="https://instagram.com/br.pagmaq?igshid=YzAwZjE1ZTI0Zg%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={InstagramImg} alt="Instagram" className="Auth_SocialIcon" />
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=5537920007857&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={WhatsappImg} alt="Whatsapp" className="Auth_SocialIcon" />
            </a>
          </div>


        </Col>

        <Col xs={24} md={14} lg={14} xl={14} className="Auth_AuthImage">
          {authImage && (
            <img className="Auth_AuthImage" src={authImage} alt="auth" />
          )}
        </Col>

      </Row>
    </div>
  );
};

Auth.propTypes = { // Corrigindo erros de Eslint
  authFields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      placeholder: PropTypes.string,
      value: PropTypes.string,
      setField: PropTypes.func,
      error: PropTypes.string,
      type: PropTypes.string,
    })
  ).isRequired,
  authSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  authImage: PropTypes.string,
  onsubmit: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  textImage: PropTypes.string,
};

export default Auth;
